<template>
  <!-- Table Container Card -->
  <b-card id="page-companies" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12" sm="12" md="4" lg="4" xl="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>

      <b-col cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button
            id="tooltip-downlaod"
            variant="info"
            @click="onCreateFast"
            class="mr-1"
          >
            <feather-icon icon="EditIcon" class="mr-25" size="18" />
            <span class="text-nowrap">{{ $t(label("registerFast")) }}</span>
          </b-button>

          <b-button id="tooltip-create" variant="primary" @click="onCreate">
            <feather-icon icon="PlusIcon" class="mr-25" size="18" />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>

      <b-col
        cols="12"
        sm="12"
        md="8"
        lg="8"
        xl="8"
        class="d-md-none d-flex justify-content-end align-items-center pt-2"
      >
        <b-button
          id="tooltip-create"
          variant="info"
          @click="onCreateFast"
          class="btn-icon mr-1"
        >
          <feather-icon icon="EditIcon" size="18" aria-label="Register" />
        </b-button>

        <b-button
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" aria-label="Register" />
        </b-button>
      </b-col>

      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <!-- Table for larger devices -->
    <b-table
      id="companies-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(guid)="data">
        <slot name="cell-guid" :data="data">
          <b-badge
            pill
            :variant="'light-success'"
            @click="info(data.value)"
            style="margin-right: 3px"
          >
            <feather-icon class="text-success" size="18" icon="KeyIcon" />
          </b-badge>

          <b-button
            class="btn-icon"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="bg-info bg-darken-2"
            v-clipboard:copy="data.value"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <feather-icon icon="CopyIcon" />
          </b-button>
        </slot>
      </template>

      <template #cell(nameCountry)="data">
        <slot name="cell-nameCountry" :data="data">
          {{ data.item.nameCountry || "N/A" }}
        </slot>
      </template>

      <template #cell(nameCity)="data">
        <slot name="cell-nameCity" :data="data">
          {{ data.item.nameCity || "N/A" }}
        </slot>
      </template>

      <template #cell(phoneNumber)="data">
        <slot name="cell-phoneNumber" :data="data">
          {{ data.item.phoneNumber || "N/A" }}
        </slot>
      </template>

      <!-- active -->
      <template #cell(sucursal)="data">
        <slot name="cell-sucursal" :data="data">
          <b-badge pill :variant="tagsColor(data.item.sucursal)">
            <span>{{
              data.item.sucursal ? "Sucursal" : "Oficina Principal"
            }}</span>
          </b-badge>
        </slot>
      </template>

      <template #cell(actions)="data">
        <slot name="cell-actions" :data="data">
          <feather-icon
            class="text-success mr-25 cursor-pointer"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.guid)"
            aria-label="Show details"
          />
          <feather-icon
            v-if="!data.item.sucursal"
            class="text-info mr-25"
            size="18"
            icon="TrelloIcon"
            @click="onCreateSucursal(data.item.guid)"
            aria-label="Create sucusal"
          />
          <feather-icon
            class="text-primary mr-25 cursor-pointer"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.guid)"
            aria-label="edit details"
          />
          <feather-icon
            v-if="data.item.productsAndServices || data.item.productss"
            class="text-info cursor-pointer"
            size="18"
            icon="DownloadCloudIcon"
            @click="onDownload(data.item.urlTemplateExcelProducts)"
          />
          <feather-icon
            class="text-danger cursor-pointer"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.guid)"
            aria-label="Delete details"
          />
        </slot>
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idClient"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong> {{ item.name }}</strong>
            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item @click="onShow(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-success mr-25"
                    size="18"
                    icon="FileTextIcon"
                  />
                  {{ $t("show") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item @click="onEdit(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-primary mr-25"
                    size="18"
                    icon="EditIcon"
                  />
                  {{ $t("edit") }}
                </div>
              </b-dropdown-item>
              <b-dropdown-item @click="onDelete(item.guid)">
                <div class="d-flex align-items-center justify-content-between">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                  />
                  {{ $t("delete") }}
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <p class="m-0">
            <strong>{{ $t(labelHeader("country")) }}: </strong>
            {{
              item.nameCountry ? item.nameCountry + " " + item.nameCity : "N/A"
            }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("phone")) }}: </strong>
            {{ item.phoneNumber || "N/A" }}
          </p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner class="align-middle ml-50" variant="primary"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>

    <!-- Modal de registro rápido -->
    <b-modal
      id="modal-registro-rapido"
      :title="$t(labelForm('register'))"
      size="lg"
      :hide-footer="false"
      @ok="handleSubmit"
      @hidden="resetModal"
      ok-title="Guardar"
      cancel-title="Cancelar"
      no-close-on-backdrop
    >
      <validation-observer ref="companyform">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(labelForm('name'))" label-for="name">
                <validation-provider
                  :name="$t(labelForm('name'))"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="company.name"
                    :placeholder="$t(labelForm('name'))"
                    :state="errors.length > 0 ? false : null"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(labelForm('phone'))" label-for="phone">
                <validation-provider
                  :name="$t(labelForm('phone'))"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="phone"
                    v-model="company.phoneNumber"
                    :placeholder="$t(labelForm('phone'))"
                    type="tel"
                    :state="errors.length > 0 ? false : null"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group :label="$t(labelForm('email'))" label-for="email">
                <validation-provider
                  :name="$t(labelForm('email'))"
                  #default="{ errors }"
                  rules="email"
                >
                  <b-form-input
                    id="email"
                    v-model="company.email"
                    :placeholder="$t(labelForm('email'))"
                    type="email"
                    :state="errors.length > 0 ? false : null"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(labelForm('address'))"
                label-for="address"
              >
                <validation-provider
                  :name="$t(labelForm('address'))"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="address"
                    v-model="company.address"
                    :placeholder="$t(labelForm('address'))"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(labelForm('startTime'))"
                label-for="startTime"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(labelForm('startTime'))"
                  rules="required"
                >
                  <b-form-input
                    id="hourOpening"
                    type="time"
                    v-model="company.workingHoursFrom"
                    :placeholder="$t(labelForm('hourOpening'))"
                    :state="errors.length > 0 ? false : null"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(labelForm('endTime'))"
                label-for="endTime"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(labelForm('endTime'))"
                  rules="required"
                >
                  <b-form-input
                    id="hourClosing"
                    type="time"
                    v-model="company.workingHoursTo"
                    :placeholder="$t(labelForm('hourClosing'))"
                    :state="errors.length > 0 ? false : null"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(labelForm('description'))"
                label-for="description"
              >
                <validation-provider
                  :name="$t(labelForm('address'))"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-textarea
                    id="description"
                    v-model="company.description"
                    :placeholder="$t(labelForm('description'))"
                    rows="3"
                  />
                  <span v-if="errors.length" class="text-danger">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(labelForm('logo'))"
                label-for="inputFilePhoto"
              >
                <b-media class="body-style">
                  <div v-if="!company.urlLogo">
                    <input
                      id="inputFilePhoto"
                      ref="fileInputPhoto"
                      name="inputFilePhoto"
                      type="file"
                      class="hidden"
                      accept=".png,.peg,.jpg,.jpeg"
                      @change="onFileChange($event, 'urlLogo')"
                    />
                    <div
                      class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                      accept=".png,.peg,.jpg,.jpeg"
                      @drop="handleDrop($event, 'urlLogo')"
                      @dragover="handleDragover"
                      @dragenter="handleDragover"
                      @click="$refs.fileInputPhoto.click()"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        size="20"
                        svg-classes="h-16 w-16 stroke-current text-grey"
                      />
                      <span
                        style="margin-left: 5px"
                        @click.stop="$refs.fileInputPhoto.click()"
                        >{{ $t(labelForm("logo")) }}
                      </span>
                    </div>
                  </div>

                  <template v-if="company.urlLogo" #aside>
                    <div class="image-company">
                      <img
                        id="image"
                        ref="image"
                        :src="company.urlLogo"
                        class="img-avatar border-dashed"
                      />
                    </div>
                    <div
                      v-if="company.urlLogo"
                      class="d-flex flex-wrap"
                      style="width: 10px"
                    >
                      <b-button
                        variant="primary"
                        style="height: 30px; width: 30px; padding: 4px"
                        @click="deleteFile('urlLogo')"
                      >
                        <feather-icon icon="XIcon" size="21" />
                      </b-button>
                    </div>
                  </template>
                </b-media>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </validation-observer>
    </b-modal>
  </b-card>
</template>
<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BFormTextarea,
  BButton,
  BTable,
  BPagination,
  BSpinner,
  BBadge,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BModal,
  BMedia,
  BFormDatepicker,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Filterss from "../components/filters/Filterss.vue";
import { allCompanies, deleteCompany } from "@/@core/api/request/company";
import { allCountries } from "@core/api/request/countries";
import { getCatalog } from "@core/api/request/catalogs";
import { postFile } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { createCompanyFast } from "@core/api/request/company";
import moment from "moment";

const company = {
  name: null,
  description: null,
  address: null,
  phoneNumber: null,
  email: null,
  urlLogo: null,
  workingHoursFrom: null,
  workingHoursTo: null,
};
export default {
  components: {
    ValidationProvider,
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BOverlay,
    Filterss,
    BModal,
    BFormTextarea,
    BMedia,
    ValidationObserver,
    BFormDatepicker,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "companies",
    loading: false,
    loadingCities: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "guid", key: "guid", sortable: true },
      { label: "name", key: "name", sortable: true },
      { label: "country", key: "nameCountry", sortable: true },
      { label: "city", key: "nameCity", sortable: false },
      { label: "phone", key: "phoneNumber", sortable: false },
      { label: "sucursal", key: "sucursal", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    appliedFilters: {},
    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "search",
        visible: true,
      },
      {
        name: "companieType",
        title: "selectCompanyType",
        placeholder: "selectCompanyType",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
      {
        name: "country",
        title: "selectCountry",
        placeholder: "selectCountry",
        type: "select",
        options: [],
        visible: true,
        multiple: false,
        close: true,
      },
    ],
    isModalOpen: false,
    company: Object.assign(company),
  }),
  created() {
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();

        const [companiesResp, companiestypesResp, countriesResp] =
          await Promise.all([
            allCompanies(params),
            getCatalog(
              getParams([
                "itemsPage,1",
                "itemsRows,999",
                "guidCatalog,e1a80765-e23a-4627-b0e9-9fa95f376726",
              ]),
            ),
            allCountries(),
          ]);

        const companies = _.get(companiesResp, "data");
        this.items = companies?.items || [];
        this.totalRows = companies?.totalRows || 0;
        this.hasNextPage = companies?.currentPage < companies?.totalPages || 0;

        const companiestypes = _.get(
          companiestypesResp,
          "data.listOfItems.items",
        );
        const transformedItemsCompanies = companiestypes.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        const countries = _.get(countriesResp, "data.items");
        const transformedItemsCountries = countries.map((item) => ({
          label: item.name,
          value: item.idCountry,
        }));

        this.fildsToFilters.forEach((element) => {
          if (element.name === "companieType") {
            element.options = transformedItemsCompanies;
          }
          if (element.name === "country") {
            element.options = transformedItemsCountries;
          }
        });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    loadCompaniesInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const param = this.chargeParams();
        allCompanies(param)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            this.hasNextPage = data?.currentPage < data?.totalPages || 0;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.log("error", error.message);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      }
    },
    label(field) {
      return `pages.companies.table.${field}`;
    },
    labelHeader(field) {
      return `pages.companies.table.tableHeader.${field}`;
    },
    labelForm(field) {
      return `pages.companies.form.label.${field}`;
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }
      if (this.appliedFilters.country) {
        arrParams.push(`idCountry,${this.appliedFilters.country}`);
      }
      if (this.appliedFilters.companieType) {
        arrParams.push(`idCompanyType,${this.appliedFilters.companieType}`);
      }
      return getParams(arrParams);
    },
    handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        this.loadCompaniesInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.loadData();
    },
    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      // Validar categoría (debe existir en las opciones disponibles)
      if (
        filters.country &&
        !this.fildsToFilters
          .find((f) => f.name === "country")
          .options.some((opt) => opt.value === filters.country)
      ) {
        console.error("El filtro de companieType no es válido.");
        return false;
      }

      // Validar condición del producto (debe existir en las opciones disponibles)
      if (
        filters.companieType &&
        !this.fildsToFilters
          .find((f) => f.name === "companieType")
          .options.some((opt) => opt.value === filters.companieType)
      ) {
        console.error("El filtro de companieType no es válido.");
        return false;
      }

      return true;
    },
    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },
    resetFilters() {
      console.log("Resetting filters");
      this.appliedFilters = {};
      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    info(guid) {
      this.$swal({
        title: "Guid",
        text: guid,
        icon: "info",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    onCreate() {
      this.$router.push({
        name: "companyCreate",
        params: { option: 1 },
      });
    },
    onShow(guid) {
      this.$router.push({
        name: "companyEdit",
        params: { option: 2, guid: guid },
      });
    },
    onCreateSucursal(guid) {
      this.$router.push({
        name: "sucursalCreate",
        params: { option: 1, guid: guid },
      });
    },
    onEdit(guid) {
      this.$router.push({
        name: "companyEdit",
        params: { option: 3, guid: guid },
      });
    },
    onDelete(guid) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteCompany(guid)
            .then(() => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadData();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", this.$t("codeAlert"), error.message);
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },
    onInfo() {
      console.log("Displaying tutorial info");
    },
    onDownload(urlTemplateExcelProducts) {
      if (urlTemplateExcelProducts != null) {
        window.open(urlTemplateExcelProducts, "_blank");
      } else {
        this.alertToast(
          "danger",
          "Error",
          "Archivo no disponible",
          "AlertTriangleIcon",
        );
      }
    },
    onCopy() {
      this.alertToast(
        "success",
        "Texto copiado!",
        "Texto copiado al portapapeles!",
        "CheckIcon",
      );
    },
    onError() {
      this.alertToast(
        "danger",
        "Alerta",
        "Error al copiar el texto!",
        "AlertTriangleIcon",
      );
    },
    tagsColor(type) {
      if (type) return "light-info";
      else return "light-success";
    },
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },

    // Abre el modal para cración rápida
    onCreateFast() {
      this.resetCompanyForm();
      this.$bvModal.show("modal-registro-rapido");
    },
    handleSubmit(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();

      this.$refs.companyform.validate().then((success) => {
        console.log("Validation->", success);
        if (success) {
          const body = {
            name: this.company.name,
            description: this.company.description,
            address: this.company.address,
            phoneNumber: this.company.phoneNumber,
            email: this.company.email,
            urlLogo: this.company.urlLogo,
            workingHoursFrom: moment(
              this.company.workingHoursFrom,
              "HH:mm",
            ).format("HH:mm:ss"),
            workingHoursTo: moment(this.company.workingHoursTo, "HH:mm").format(
              "HH:mm:ss",
            ),
          };
          showLoading();
          createCompanyFast(body)
            .then((response) => {
              console.log("Response ->", response);
              stopLoading();
              if (!response.err) {
                // Cerrar el modal
                this.$bvModal.hide("modal-registro-rapido");
                // Recargar los datos
                this.loadData();
              } else {
                this.alertToast(
                  "danger",
                  "Error",
                  response.message,
                  "AlertTriangleIcon",
                );
              }
            })
            .catch((er) => {
              console.log(er);
              stopLoading();
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
            });
        } else {
          this.alertToast(
            "danger",
            "Error",
            "Complete los campos requeridos",
            "AlertTriangleIcon",
          );
        }
      });

      // Aquí puedes hacer la llamada a la API para guardar
      console.log("Datos del formulario:", this.company);
    },
    resetModal() {
      this.resetCompanyForm();
    },
    resetCompanyForm() {
      this.company = {
        name: null,
        description: null,
        address: null,
        phoneNumber: null,
        email: null,
        urlLogo: null,
        workingHoursFrom: null,
        workingHoursTo: null,
      };
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    deleteFile(field) {
      this.company[field] = null;
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },
    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      // this.loadingPhoto = true
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.company[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            // this.loadingPhoto = false
            stopLoading();
          });
      });
    },
  },
};
</script>
<style lang="scss">
.mr-8 {
  margin-right: 8px !important;
}
.image-company {
  height: auto !important;
  width: auto !important;
}
</style>
